module.exports = __webpack_public_path__ + "img/default_asphalted_and_unstabilized.f325836d.png";